
<template>
    <div class="center">
      <vs-dialog v-model="active" prevent-close>
        <template #header>
          <h4 class="not-margin">
              <span>Cancelar factura</span>
          </h4>
        </template>


        <div class="con-form">
            <div class="con-content">
              <p>
                  La factura de <b> {{ row.concepto ? row.concepto : '' | uppercase }}</b>
              </p>
              <p class="salto mb-1" v-if="row.factura && row.factura.uuid"><strong>UUID:</strong> <i class="fas fa-barcode"></i> {{ row.factura && row.factura.uuid ? row.factura.uuid : 'UUID No definido'}}</p>
              <p class="salto"  v-if="row.factura && row.factura.fecha_factura"><strong>F.Factura:</strong> <i class="far fa-calendar"></i> {{ row.factura && row.factura.fecha_factura ? row.factura.fecha_factura : 'F. Factura No definido'}}</p>

              <p class="mb">MOTIVO DE CANCELACIÓN</p>
              <p><strong>02 - Comprobantes emitidos con errores sin relación</strong></p>
            </div>
        </div>

        <template #footer>
          <div class="footer-dialog" style="display:flex; justify-content: space-between">  
            <vs-button style="width: 25%" block danger class="color-red" >
              Cancelar
            </vs-button>
            <vs-button style="width: 25%" block success @click="getCancelarFactura()">
              Aceptar
            </vs-button>        
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import cobranza from '../../../../api/requests/cobranza-persona'
    export default {
        props:[
          'value',
          'row',
          'institucion'
        ],
        data:() => ({
            active: false,
            motivo: '02',
            errorFields: []
        }),
        methods:{
          async getCancelarFactura(){
                const loading = this.$vs.loading()
                try { 
                  const params = {
                    uuid: this.row.factura.uuid,
                    motivo: '02'
                  }
                  const response = await cobranza.postCancelar4(params)
                  if(response.status === 200) {
                    this.active = false
                    this.$vs.notification({
                        progress: 'auto',                           
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa',
                        text: response.data.message
                    })
                    this.$emit('refreshTable');
                    loading.close()
                  }
                } catch (error) {
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Error',
                        text: error.response.data.message
                    })
                }
          },
        },
        watch: {
            value (val) {
                this.active = val
            },
            active (val) {
                if (!val){
                    this.$emit('input', val);
                }
            },
        }
    }
</script>
